import Box from '~/common/mui/Layout/Box';

type FieldArrayContainerProps = {
  children: React.ReactNode;
};

export function FieldArrayContainer({
  children,
}: Readonly<FieldArrayContainerProps>) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '1.5rem',
        alignItems: 'flex-start',
        width: '100%',
        padding: '0 0.5rem',
      }}
    >
      {children}
    </Box>
  );
}
